import React from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const WaitConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          Várakozási idő
        </label>
        <div className="flex space-x-2">
          <input
            type="number"
            value={node.data.config.duration || 60}
            onChange={(e) => updateConfig('duration', parseInt(e.target.value))}
            className={`flex-1 ${commonStyles.input}`}
            min="1"
          />
          <select
            value={node.data.config.unit || 'seconds'}
            onChange={(e) => updateConfig('unit', e.target.value)}
            className={commonStyles.select}
          >
            <option value="seconds">másodperc</option>
            <option value="minutes">perc</option>
            <option value="hours">óra</option>
            <option value="days">nap</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default WaitConfig;
